export default __webpack_public_path__ + "static/media/showers.85346727.png";